import { SvgBase } from "../svg.base";

export const Close = () => (
  <SvgBase
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <path
      id="a"
      fill="currentColor"
      d="M22 9.41L20.59 8 15 13.59 9.41 8 8 9.41 13.59 15 8 20.59 9.41 22 15 16.41 20.59 22 22 20.59 16.41 15z"
    />
  </SvgBase>
);